import { inputStatusConfig, mockAllocationStatusConfig } from './constants/MockAllocationConstants';
import { InputStatus, MockAllocationStatus, MockStatus, RightHeaderType } from '../../types';
import SuccessAvatarIcon from '@cp/src/assets/icons/SuccessAvatarIcon';
import { MockAllocationDetails } from '../../interface';
import PostAllocationStatus from './TimelineData/PostAllocationStatus';
import { downloadDocumentFromS3WithoughtPreview } from '@cp/src/utils/DocumentDownloadFromS3';

export const getTimelineData = (
  allocationData: MockAllocationDetails,
  showPreviousAllocationDetails?: boolean
) => {
  const inputStatus = allocationData?.inputPreparationData?.preparationStatus?.value;
  const mockAllocationStatus = allocationData?.mockAllocationData?.preparationStatus?.value;

  if (!inputStatus || !mockAllocationStatus) {
    return [];
  }

  const inputConfig = inputStatusConfig(showPreviousAllocationDetails)[inputStatus as InputStatus];
  const mockAllocationConfig = mockAllocationStatusConfig(showPreviousAllocationDetails)[
    mockAllocationStatus as MockAllocationStatus
  ];
  const timelineData = [];

  if (inputConfig) {
    timelineData.push({
      pointer: inputConfig.icon,
      stageComponent: inputConfig.component
    });
    if (mockAllocationConfig) {
      timelineData.push({
        pointer: mockAllocationConfig.icon,
        stageComponent: mockAllocationConfig.component
      });
      if (
        mockAllocationStatus === MockAllocationStatus.SUCCESS &&
        allocationData?.status?.value !== MockStatus.COMPLETED
      ) {
        timelineData.push({
          pointer: <SuccessAvatarIcon />,
          stageComponent: (
            <PostAllocationStatus showPreviousAllocation={showPreviousAllocationDetails} />
          )
        });
      }
    }
  }

  return timelineData;
};

export const getRightHeaderLabel = (
  status: MockStatus,
  component?: string,
  mockOutputStatus?: MockAllocationStatus
): string => {
  switch (status) {
    case MockStatus.INPUTS_READY:
      return 'Can take up-to 3 hours once triggered';

    case MockStatus.IN_PROGRESS:
      return 'Can take up-to 3 hours. Refresh to view current status';

    case MockStatus.FAILED:
      if (
        mockOutputStatus === MockAllocationStatus.FAILURE &&
        component === RightHeaderType.OUTPUT
      ) {
        return 'Infeasible LPP results';
      }
      return '';

    case MockStatus.PREPARING_INPUTS:
    case MockStatus.INITIATED:
      if (component === RightHeaderType.INPUT) {
        return 'Can take up to 10 min. Refresh to view current status';
      }
      return 'You can trigger once inputs are ready';

    default:
      return '';
  }
};

export const getMockId = (allocationTrcakerId: string) => {
  return allocationTrcakerId?.split('|').pop()?.substring(0, 10);
};

export const handleDownload = (presignedUrl: string, fileName: string) => {
  return () => {
    if (!presignedUrl) return;
    downloadDocumentFromS3WithoughtPreview(presignedUrl, fileName, `${fileName} download failed`);
  };
};
